import { useState } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { PageLink, PageTitle } from '@/_metronic/layout/core';
import DetailRecruitment from '@/modules/recruitment-organization/components/DetailRecruitment';
import { RecruitmentListWrapper } from '@/modules/recruitment-organization/components/table/RecruitmentList';

const RecruitmentOrganizationPage = () => {
  const [breadcrumbName, setBreadcrumbName] = useState<string>('');
  const Breadcrumbs: Array<PageLink> = [
    {
      isActive: false,
      isSeparator: false,
      path: '/recruitment-organization/list',
      // QC #13/#24 — page used to be titled "Danh sách chiến dịch tuyển
      // dụng" which is identical to /recruitment-plan/list. Rename to
      // make the role split explicit: KD plans on /recruitment-plan,
      // TD acts on data trong chiến dịch ở /recruitment-organization.
      title: 'Tổ chức tuyển dụng — Thao tác data NLĐ theo chiến dịch',
    },
    {
      isActive: false,
      isSeparator: true,
      path: '',
      title: '',
    },
  ];

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          element={
            <>
              <PageTitle breadcrumbs={Breadcrumbs} />
              <RecruitmentListWrapper />
            </>
          }
          path="list"
        />
      </Route>

      <Route
        element={
          <>
            <DetailRecruitment breadcrumbName={(value: string) => setBreadcrumbName(value)} />
            <Outlet />
          </>
        }
      >
        <Route
          element={
            <PageTitle breadcrumbs={Breadcrumbs}>
              <h6 className="m-0">
                <span className="fs-5 text-muted">Chi tiết chiến dịch tuyển dụng</span> -{' '}
                {breadcrumbName}
              </h6>
            </PageTitle>
          }
          path=":id"
        />
      </Route>
    </Routes>
  );
};

export default RecruitmentOrganizationPage;
